
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ArrowRight, LifeBuoy, Users } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
const Thanks = () => {
  return <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <main className="flex-grow flex flex-col items-center p-4 sm:p-6 lg:p-8 pt-24 sm:pt-32">
        <div className="w-full max-w-2xl mx-auto">
          <Card className="overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300 border border-[#FEE6D8] my-12 sm:my-20">
            <CardHeader className="text-center p-4 sm:p-6">
              <CardTitle className="text-2xl sm:text-3xl font-bold text-[#003a70]">Welcome to AskSpot!</CardTitle>
              <CardDescription className="text-gray-600 mt-2">
                You're all set! Watch this short video to get started on your journey.
              </CardDescription>
            </CardHeader>
            <CardContent className="px-4 pb-4 sm:px-6 sm:pb-6 md:px-8 md:pb-8">
              {/* Video Placeholder */}
              <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center mb-8 border border-dashed">
                <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <Button asChild size="lg" className="w-full">
                  <a href="https://app.askspot.ai/login" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center">
                    <ArrowRight className="mr-2 h-5 w-5" />
                    Login
                  </a>
                </Button>
                <Button asChild variant="secondary" size="lg" className="w-full">
                  <Link to="/contact" className="flex items-center justify-center">
                    <LifeBuoy className="mr-2 h-5 w-5" />
                    Support
                  </Link>
                </Button>
                <Button asChild variant="secondary" size="lg" className="w-full">
                  <a href="https://www.facebook.com/groups/askspot" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center">
                    <Users className="mr-2 h-5 w-5" />
                    Community
                  </a>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>;
};
export default Thanks;
